import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form"];
  static values = { index: Number };

  next(event) {
    if (event.detail.success) {
      if (this.indexValue < this.formTargets.length - 1) {
        this.formTargets[this.indexValue].classList.add("hidden");
        this.indexValue += 1;
        this.formTargets[this.indexValue].classList.remove("hidden");
      }
    }
  }

  previous() {
    if (this.indexValue > 0) {
      this.formTargets[this.indexValue].classList.add("hidden");
      this.indexValue -= 1;
      this.formTargets[this.indexValue].classList.remove("hidden");
    }
  }
}
